(function() {
  const COLLECTION = 'all';
  const BASE_URL = '/collections/' + COLLECTION;
  const STOREFRONT_TOKEN = document.querySelector('[data-storefront-token]')?.dataset.storefrontToken || '';

  const typeEl   = document.getElementById('hfb-type');
  const brandEl  = document.getElementById('hfb-brand');
  const genderEl = document.getElementById('hfb-gender');
  const countEl  = document.getElementById('hfb-count-num');
  const resetBtn = document.getElementById('hfb-reset');
  const searchBtn= document.getElementById('hfb-search');

  // Memory Stores
  let allProductsCache = [];
  let typeVendorMap   = {};
  let vendorGenderMap = {};
  let vendorTypeMap   = {};
  let genderTypeMap   = {};
  let genderVendorMap = {};
  let allTypes        = [];
  let allVendors      = [];
  let allGenders      = [];

  // Group every product type beginning with "Hi Vis" in the finder.
  function finderType(type) {
    return /^hi vis/i.test(type || '') ? 'Hi Vis' : type;
  }

  // ── Storefront API helper ─────────────────────────────────────────────────
  async function storefrontQuery(query, variables = {}) {
    const res = await fetch('/api/2026-04/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({ query, variables })
    });
    return res.json();
  }

  // ── Parallel Product Loader ───────────────────────────────────────────────
  async function fetchAllProducts() {
  const CACHE_KEY = 'hfb_products_v3';
  const CACHE_TTL = 60 * 60 * 1000; // 1 hour cache

  // 1. Check local storage cache first
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    if (cached) {
      const { timestamp, products } = JSON.parse(cached);
      if (Date.now() - timestamp < CACHE_TTL) {
        console.log('HFB: loaded from cache');
        return products;
      }
    }
  } catch(e) {}

  // 2. Define vendor ranges to split work across parallel requests
  const slices = [
    "vendor:A* OR vendor:B* OR vendor:C* OR vendor:D* OR vendor:E* OR vendor:F*",
    "vendor:G* OR vendor:H* OR vendor:I* OR vendor:J* OR vendor:K* OR vendor:L*",
    "vendor:M* OR vendor:N* OR vendor:O* OR vendor:P* OR vendor:Q* OR vendor:R*",
    "vendor:S* OR vendor:T* OR vendor:U* OR vendor:V* OR vendor:W* OR vendor:X* OR vendor:Y* OR vendor:Z*",
    "NOT vendor:A* AND NOT vendor:B* AND NOT vendor:C* AND NOT vendor:D* AND NOT vendor:E* AND NOT vendor:F* AND NOT vendor:G* AND NOT vendor:H* AND NOT vendor:I* AND NOT vendor:J* AND NOT vendor:K* AND NOT vendor:L* AND NOT vendor:M* AND NOT vendor:N* AND NOT vendor:O* AND NOT vendor:P* AND NOT vendor:Q* AND NOT vendor:R* AND NOT vendor:S* AND NOT vendor:T* AND NOT vendor:U* AND NOT vendor:V* AND NOT vendor:W* AND NOT vendor:X* AND NOT vendor:Y* AND NOT vendor:Z*" // Catches numbers & special characters
  ];

  const query = `
    query GetProductsSlice($q: String, $cursor: String) {
      products(first: 250, query: $q, after: $cursor) {
        pageInfo { hasNextPage endCursor }
        edges {
          node {
            id
            productType
            vendor
            genderMeta: metafield(namespace: "custom", key: "gender") {
              value
            }
          }
        }
      }
    }
  `;

  // Fetch a single slice (handles pagination inside the slice if needed)
  const fetchSlice = async (sliceQuery) => {
    let sliceProducts = [];
    let cursor = null;
    let hasMore = true;

    while (hasMore) {
      const data = await storefrontQuery(query, { q: sliceQuery, cursor });
      const page = data?.data?.products;
      if (!page) break;

      sliceProducts.push(...page.edges.map(e => e.node));
      hasMore = page.pageInfo.hasNextPage;
      cursor = page.pageInfo.endCursor;
    }

    return sliceProducts;
  };

  // 3. Fire all 5 requests simultaneously in parallel
  console.time('HFB Parallel Load');
  const results = await Promise.all(slices.map(s => fetchSlice(s)));
  console.timeEnd('HFB Parallel Load');

  // 4. Flatten and deduplicate items across slices
  const productMap = new Map();
  results.flat().forEach(p => productMap.set(p.id, p));
  const products = Array.from(productMap.values());

  // 5. Save to local storage cache
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify({ timestamp: Date.now(), products }));
  } catch(e) {}

  return products;
}

  // ── Map Builder ───────────────────────────────────────────────────────────
  function buildMaps(products) {
    allProductsCache = products; // Store for zero-latency local filtering

    products.forEach(p => {
      const type   = finderType(p.productType);
      const vendor = p.vendor;
      if (!type || !vendor) return;

      if (!typeVendorMap[type])   typeVendorMap[type]   = new Set();
      typeVendorMap[type].add(vendor);

      if (!vendorTypeMap[vendor]) vendorTypeMap[vendor] = new Set();
      vendorTypeMap[vendor].add(type);

      const genderValues = p.genderMeta?.value ? JSON.parse(p.genderMeta.value) : [];
      if (!genderValues.length) return;

      const key = `${type}||${vendor}`;
      if (!vendorGenderMap[key]) vendorGenderMap[key] = new Set();

      genderValues.forEach(g => {
        vendorGenderMap[key].add(g);

        if (!genderTypeMap[g])   genderTypeMap[g]   = new Set();
        if (!genderVendorMap[g]) genderVendorMap[g] = new Set();
        genderTypeMap[g].add(type);
        genderVendorMap[g].add(vendor);
      });
    });

    allTypes   = [...new Set(products.map(p => finderType(p.productType)).filter(Boolean))].sort();
    allVendors = [...new Set(products.map(p => p.vendor).filter(Boolean))].sort();
    allGenders = Object.keys(genderTypeMap).sort();
  }

  // ── Populate Dropdowns ────────────────────────────────────────────────────
  function populateSelect(el, values, placeholder) {
    const current = el.value;
    el.innerHTML = `<option value="">${placeholder}</option>`;
    values.forEach(v => {
      const o = document.createElement('option');
      o.value = v; o.textContent = v;
      if (v === current) o.selected = true;
      el.appendChild(o);
    });
  }

  function updateTypeOptions() {
    const vendor = brandEl.value;
    const gender = genderEl.value;
    let types = new Set(allTypes);
    if (vendor) types = new Set([...types].filter(t => (vendorTypeMap[vendor] || new Set()).has(t)));
    if (gender && Object.keys(genderTypeMap).length) {
      const genderTypes = genderTypeMap[gender];
      if (genderTypes && genderTypes.size) {
        types = new Set([...types].filter(t => genderTypes.has(t)));
      }
    }
    populateSelect(typeEl, [...types].sort(), 'Choose your product type...');
  }

  function updateBrandOptions() {
    const type   = typeEl.value;
    const gender = genderEl.value;
    let vendors = new Set(allVendors);
    if (type)   vendors = new Set([...vendors].filter(v => (typeVendorMap[type] || new Set()).has(v)));
    if (gender && Object.keys(genderVendorMap).length) {
      const genderVendors = genderVendorMap[gender];
      if (genderVendors && genderVendors.size) {
        vendors = new Set([...vendors].filter(v => genderVendors.has(v)));
      }
    }
    populateSelect(brandEl, [...vendors].sort(), 'Choose a brand...');
    brandEl.disabled = false;
  }

  function updateGenderOptions() {
    const type   = typeEl.value;
    const vendor = brandEl.value;
    let genders = [];

    if (type && vendor) {
      const key = `${type}||${vendor}`;
      genders = [...(vendorGenderMap[key] || new Set())].sort();
    } else if (type) {
      genders = allGenders.filter(g => (genderTypeMap[g] || new Set()).has(type));
    } else if (vendor) {
      genders = allGenders.filter(g => (genderVendorMap[g] || new Set()).has(vendor));
    } else {
      // No filters applied — show all genders that exist across the catalog
      genders = allGenders.filter(g => genderTypeMap[g] || genderVendorMap[g]);
    }

    // Check if a Type or Brand was chosen, but has NO available gender metadata
    const hasFilterActive = Boolean(type || vendor);
    const hasNoGendersAvailable = hasFilterActive && genders.length === 0;

    if (hasNoGendersAvailable) {
      // Reset selected value, disable dropdown, and show helpful placeholder
      genderEl.value = '';
      populateSelect(genderEl, [], 'N/A (No gender options)');
      genderEl.disabled = true;
    } else {
      // Enable and populate normal available options
      genderEl.disabled = false;
      populateSelect(genderEl, genders.length ? genders : allGenders, 'Choose gender...');
    }
  }

  // ── Instant In-Memory Counting ────────────────────────────────────────────
  function updateCount() {
    const selectedType   = typeEl.value;
    const selectedBrand  = brandEl.value;
    const selectedGender = genderEl.value;

    // Filter local JavaScript memory array directly
    const matching = allProductsCache.filter(p => {
      if (selectedType && finderType(p.productType) !== selectedType) return false;
      if (selectedBrand && p.vendor !== selectedBrand) return false;
      if (selectedGender) {
        const genderValues = p.genderMeta?.value ? JSON.parse(p.genderMeta.value) : [];
        if (!genderValues.includes(selectedGender)) return false;
      }
      return true;
    });

    countEl.textContent = matching.length;
  }

  // ── Event Handlers ────────────────────────────────────────────────────────
  typeEl.addEventListener('change', () => {
    updateBrandOptions();
    updateGenderOptions();
    updateCount();
  });

  brandEl.addEventListener('change', () => {
    updateTypeOptions();
    updateGenderOptions();
    updateCount();
  });

  genderEl.addEventListener('change', () => {
    updateTypeOptions();
    updateBrandOptions();
    updateCount();
  });

  resetBtn.addEventListener('click', () => {
    typeEl.value   = '';
    brandEl.value  = '';
    genderEl.value = '';

    typeEl.disabled  = false;
    brandEl.disabled = false;
    genderEl.disabled = false;

    populateSelect(typeEl,   allTypes,   'Choose your product type...');
    populateSelect(brandEl,  allVendors, 'Choose a brand...');
    
    const availableGenders = allGenders.filter(g => genderTypeMap[g] || genderVendorMap[g]);
    populateSelect(genderEl, availableGenders.length ? availableGenders : allGenders, 'Choose gender...');
    
    updateCount();
  });

    searchBtn.addEventListener('click', () => {
    const isHiVis = typeEl.value === 'Hi Vis';
    const url = isHiVis ? '/collections/hi-vis-clothing' : BASE_URL;
    const params = new URLSearchParams();

    if (typeEl.value && !isHiVis) {
      params.set('filter.p.product_type', typeEl.value);
    }
    if (brandEl.value) {
      params.set('filter.p.vendor', brandEl.value);
    }
    if (genderEl.value) {
      params.set('filter.p.m.custom.gender', genderEl.value);
    }

    window.location.href = `${url}${params.toString() ? '?' + params.toString() : ''}`;
  });


  // ── Initialization ────────────────────────────────────────────────────────
  async function init() {
    typeEl.innerHTML   = '<option value="">Loading...</option>';
    brandEl.innerHTML  = '<option value="">Loading...</option>';
    genderEl.innerHTML = '<option value="">Loading...</option>';
    typeEl.disabled = brandEl.disabled = genderEl.disabled = true;
    countEl.textContent = '…';

    try {
      // 1. Fetch initial dataset
      const products = await fetchAllProducts();

      // 2. Build local index maps
      buildMaps(products);

      // 3. Populate initial UI dropdown state
      populateSelect(typeEl,   allTypes,   'Choose your product type...');
      populateSelect(brandEl,  allVendors, 'Choose a brand...');
      const availableGenders = allGenders.filter(g => genderTypeMap[g] || genderVendorMap[g]);
      populateSelect(genderEl, availableGenders.length ? availableGenders : allGenders, 'Choose gender...');

      typeEl.disabled = brandEl.disabled = genderEl.disabled = false;

      // 4. Set initial product count instantly from memory
      countEl.textContent = products.length;
    } catch(e) {
      countEl.textContent = '—';
      console.error('HFB init error:', e);
    }
  }

  init();
})();